import React from 'react';
import { brandData, facilityData } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', href: '#home' },
    { name: 'Products', href: '#products' },
    { name: 'Capabilities', href: '#capabilities' },
    { name: 'Quality', href: '#quality' },
    { name: 'About', href: '#about' },
    { name: 'Contact', href: '#contact' }
  ];

  const productLinks = [
    { name: 'Philip Head', href: '#products' },
    { name: 'Hex Bolts', href: '#products' },
    { name: 'Self-Tapping', href: '#products' },
    { name: 'Terminal Screws', href: '#products' }
  ];

  const scrollToSection = (href) => {
    if (href === '#home') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    const element = document.querySelector(href);
    if (element) {
      const offset = 80;
      const top = element.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div>
            <div className="footer-brand">{brandData.brand_name}</div>
            <p className="footer-tagline">
              {brandData.tagline}. Manufacturing precision cold forged fasteners 
              since {facilityData.commercial_production_started_year}.
            </p>
          </div>

          <div>
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              {quickLinks.map((link) => (
                <li key={link.name} className="footer-link">
                  <button
                    onClick={() => scrollToSection(link.href)}
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="footer-title">Products</h4>
            <ul className="footer-links">
              {productLinks.map((link) => (
                <li key={link.name} className="footer-link">
                  <button
                    onClick={() => scrollToSection(link.href)}
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="footer-title">Contact</h4>
            <ul className="footer-links">
              <li className="footer-link">
                <button onClick={() => scrollToSection('#contact')}>
                  Get in Touch
                </button>
              </li>
              <li className="footer-link">
                <button onClick={() => scrollToSection('#contact')}>
                  Request Quote
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} {brandData.legal_name}. All rights reserved.
          </p>
          <p className="footer-address">
            {facilityData.location}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
